// extracted by mini-css-extract-plugin
export var connectionButton = "_9g-1";
export var rightPanel = "_9g-3";
export var stepDescription = "_9g-2";
export var stepIcon = "_9g-0";